import type { AssistantMessage } from './types';

// Long runs of finished tool steps (freeform edits make many) collapse into
// one expandable "N passos" row. Action cards and a step still running stay
// on their own.

export const STEP_GROUP_MIN = 4;

export type AssistantChatItem =
  | { type: 'message'; message: AssistantMessage }
  | { type: 'steps'; id: string; messages: AssistantMessage[]; failed: number };

const isFinishedStep = (message: AssistantMessage) => message.role === 'tool'
  && !message.action
  && message.tool_status !== null;

export function groupAssistantSteps(
  messages: readonly AssistantMessage[],
  { inProgress }: { inProgress: boolean },
): AssistantChatItem[] {
  const items: AssistantChatItem[] = [];
  let run: AssistantMessage[] = [];
  const flush = () => {
    if (run.length >= STEP_GROUP_MIN) {
      items.push({
        type: 'steps',
        id: `steps-${run[0].id}`,
        messages: run,
        failed: run.filter((message) => message.tool_status === 'error').length,
      });
    } else {
      run.forEach((message) => items.push({ type: 'message', message }));
    }
    run = [];
  };
  messages.forEach((message) => {
    // A step without a result is "running" only while the turn is in progress;
    // otherwise it reads as finished (e.g. an unanswered browser call).
    const finished = isFinishedStep(message)
      || (message.role === 'tool' && !message.action && message.tool_status === null && !inProgress);
    if (finished) {
      run.push(message);
      return;
    }
    flush();
    items.push({ type: 'message', message });
  });
  flush();
  return items;
}
